import { breakPoints } from './index';

export const productPageMobileHeaderProfiles = [
  {
    width: 620,
    height: 250,
    rule: breakPoints.sm,
  },
  {
    width: 470,
    height: 250,
    rule: breakPoints.xs,
  },
];

export const productPageMainDesktopHeaderProfiles = [
  {
    width: 805,
    height: 340,
    rule: breakPoints.xl,
  },
  {
    width: 790,
    height: 340,
    rule: breakPoints.xs,
  },
];

export const productPageSmallDesktopHeaderProfiles = [
  {
    width: 235,
    height: 165,
    rule: breakPoints.xs,
  },
];

export const heroMainImageProfiles = [
  {
    width: 610,
    height: 260,
    rule: breakPoints.xl,
  },
  {
    width: 595,
    height: 260,
    rule: breakPoints.lg,
  },
  {
    width: 595,
    height: 260,
    rule: breakPoints.md,
  },
  {
    width: 635,
    height: 260,
    rule: breakPoints.sm,
  },
  {
    width: 500,
    height: 212,
    rule: breakPoints.xs,
  },
];

export const heroSmallImageProfiles = [
  {
    width: 170,
    height: 130,
    rule: breakPoints.lg,
  },
  {
    width: 165,
    height: 130,
    rule: breakPoints.xs,
  },
];

export const accommodationGalleryProfiles = [
  {
    width: 1040,
    height: 690,
    rule: breakPoints.xl,
  },
  {
    width: 970,
    height: 645,
    rule: breakPoints.lg,
  },
  {
    width: 770,
    height: 510,
    rule: breakPoints.md,
  },
  {
    width: 740,
    height: 490,
    rule: breakPoints.sm,
  },
  {
    width: 470,
    height: 310,
    rule: breakPoints.xs,
  },
];

export const searchResultCardMainV3Profiles = [
  {
    width: 240,
    height: 230,
    rule: breakPoints.xl,
  },
  {
    width: 240,
    height: 230,
    rule: breakPoints.lg,
  },
  {
    width: 210,
    height: 120,
    rule: breakPoints.md,
  },
  {
    width: 210,
    height: 115,
    rule: breakPoints.sm,
  },
  {
    width: 350,
    height: 160,
    rule: breakPoints.xs,
  },
];

export const parkCardImageProfiles = [
  {
    width: 635,
    height: 240,
    rule: breakPoints.xl,
  },
  {
    width: 635,
    height: 240,
    rule: breakPoints.lg,
  },
  {
    width: 540,
    height: 180,
    rule: breakPoints.md,
  },
  {
    width: 500,
    height: 180,
    rule: breakPoints.sm,
  },
  {
    width: 310,
    height: 180,
    rule: breakPoints.xs,
  },
];

export const condensedParkCardImageProfiles = [
  {
    width: 130,
    height: 175,
    rule: breakPoints.xl,
  },
  {
    width: 130,
    height: 175,
    rule: breakPoints.lg,
  },
  {
    width: 130,
    height: 175,
    rule: breakPoints.md,
  },
  {
    width: 130,
    height: 175,
    rule: breakPoints.sm,
  },
  {
    width: 130,
    height: 175,
    rule: breakPoints.xs,
  },
];

export const parkFeatureAccordionImageProfiles = [
  {
    width: 280,
    height: 205,
    rule: breakPoints.lg,
  },
  {
    width: 185,
    height: 165,
    rule: breakPoints.md,
  },
  {
    width: 375,
    height: 165,
    rule: breakPoints.sm,
  },
  {
    width: 225,
    height: 120,
    rule: breakPoints.xs,
  },
];

export const searchResultCardGridProfiles = [
  {
    width: 460,
    height: 205,
    rule: breakPoints.xl,
  },
  {
    width: 460,
    height: 205,
    rule: breakPoints.lg,
  },
  {
    width: 360,
    height: 205,
    rule: breakPoints.md,
  },
  {
    width: 370,
    height: 205,
    rule: breakPoints.sm,
  },
  {
    width: 470,
    height: 205,
    rule: breakPoints.xs,
  },
];

export const pdpRecommendationsImageProfiles = [
  {
    width: 210,
    height: 120,
    rule: breakPoints.xs,
  },
];

export const promotedItemImageProfiles = [
  {
    width: 170,
    height: 105,
    rule: breakPoints.lg,
  },
  {
    width: 160,
    height: 105,
    rule: breakPoints.md,
  },
  {
    width: 140,
    height: 105,
    rule: breakPoints.sm,
  },
  {
    width: 120,
    height: 105,
    rule: breakPoints.xs,
  },
];
